import styled from 'styled-components';
import * as Cards from 'theme/components/Cards.style';
import breakpoints from 'theme/atoms/breakpoints';

export const HeaderBlock = styled('div')`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

export const Card = styled(Cards.BasicCard)`
  gap: 30px;
  border-radius: 30px;
  padding: 30px;
  max-width: unset;
  max-width: 1200px;

  @media (max-width: ${breakpoints.tablet}) {
    box-shadow: none;
  }
`;
